import type { CompetitorReport } from '../../api/types'
import { formatCount } from '../../lib/format'
import { SOURCE_LABELS } from './CompetitorTable'

const usd = (n: number | null | undefined) =>
	n === null || n === undefined ? 'unknown' : `$${n.toFixed(n > 0 && n < 0.01 ? 4 : 2)}`

/** What a report's queries cost: each LLM call's tokens and estimated price, and the App Store requests. */
export function QueryCosts({ report, cached }: { report: CompetitorReport; cached: boolean }) {
	if (report.appStoreRequests === undefined)
		return (
			<p className="muted small" style={{ margin: 0 }}>
				Query costs weren’t recorded for this report.
			</p>
		)
	const llms = report.providers.filter((p) => p.name !== 'keywords')
	return (
		<p className="muted small" style={{ margin: 0 }}>
			{cached ? (
				<>
					Reused, so this request cost nothing. The original run cost <strong>{usd(report.costUsd)}</strong>:{' '}
				</>
			) : (
				<>
					Query cost <strong>{usd(report.costUsd)}</strong>:{' '}
				</>
			)}
			{[
				...llms.map((p) =>
					p.inputTokens === null || p.inputTokens === undefined
						? `${SOURCE_LABELS[p.name]} failed (usage unknown)`
						: `${SOURCE_LABELS[p.name]} ${usd(p.costUsd)} (${formatCount(p.inputTokens)} in, ${formatCount(p.outputTokens ?? 0)} out)`,
				),
				`${report.appStoreRequests} App Store requests (free)`,
			].join(' · ')}
		</p>
	)
}
